var _circle, _circle2, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 516,
    viewBox: "0 0 516 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 258,
    r: 256,
    fill: "#233428"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 177,
    r: 27.5,
    stroke: "white",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.5,
    y: 220.5,
    width: 45,
    height: 146,
    rx: 7.5,
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 366.04V222.04C224 220.936 224.895 220.04 226 220.04H271C272.105 220.04 273 220.936 273 222.04V233.012C273 235.428 275.099 237.307 277.5 237.04C277.5 237.04 280 237.04 282.5 232.54C284.044 229.761 286.525 226.034 289 224.04C291.475 222.046 292.622 221.261 296 219.54C299.851 217.578 303.269 216.922 307.5 216.04C311.532 215.199 313.881 214.534 318 214.5C323 214.459 326 214.616 328.5 215C332.247 215.575 336 216.238 339.5 217.5C340 217.68 347.5 219.96 351 222C354.746 224.183 356.208 225.178 359.5 228C362.37 230.46 366 234 367.5 237.5C368.5 239.833 369 240.5 370 243.5C371 246.5 371.527 248.202 372 250C372.835 253.172 373 254.45 373.5 257C374 259.55 374 263.5 374 264.54C374 265.495 373.579 351.093 373.51 365.109C373.504 366.21 372.611 367.04 371.51 367.04H327.536C326.417 367.04 325.516 366.135 325.535 365.017C325.759 352.106 326.954 281.673 326.5 278.04C326 274.04 326.5 271.04 323 265.04C321.537 262.533 320.538 261.383 318 259.04C315.462 256.697 314 256.04 311 255.04C308 254.04 300.5 253.04 294 254.04C290.288 254.611 286.5 256.165 284 258.04C281.5 259.915 278.928 263.04 277.5 265.04C276.072 267.04 274.429 270.54 274 272.04L274 272.04C273.571 273.54 273 275.54 273 280.04V366.052C273 367.156 272.105 368.04 271 368.04H226C224.895 368.04 224 367.145 224 366.04Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.52c3f02647dbfaacf2633b6819875eb1.svg";
export { ForwardRef as ReactComponent };